import {Trigger} from '@models/adminstration/machine/trigger/trigger';
import {TRIGGER_ACTION_TYPE} from '@constants/trigger/trigger-action-type.constant';
import {MessageContentType} from '@models/adminstration/machine/trigger/trigger-query/message-content-type';
import {
  AdditionalMessageField,
  AdditionalMessageFieldTypes
} from '@models/adminstration/machine/trigger/trigger-query/additional-message-field/additional-message-field';
import {TRIGGER_SIGNAL_TYPE} from '@constants/administration/machine/trigger-signal-label';

export class UpdateTriggerQueryRequest {
  delayInSeconds?: string | null;
  email?: string;
  id: number;
  initQueryExecuted: boolean;
  message?: string;
  name: string;
  subject?: string;
  triggerActionType: string;
  topic?: string | null;
  notificationSubscriptions?: string[] | null;
  messageContentType: MessageContentType;
  additionalMessageFields: AdditionalMessageField[] | null;

  constructor(trigger: Trigger) {
    this.delayInSeconds = trigger.delayInSeconds;
    this.email = trigger.email;
    this.id = trigger.id;
    this.initQueryExecuted = trigger.initQueryExecuted;
    this.message = trigger.message;
    this.name = trigger.name;
    this.subject = trigger.subject;
    this.triggerActionType = trigger.triggerActionType;
    this.topic = trigger.topic;
    this.notificationSubscriptions = trigger.notificationSubscriptions;
    this.messageContentType = trigger.messageContentType;
    this.additionalMessageFields = trigger.additionalMessageFields;

    if (trigger.triggerActionType === TRIGGER_ACTION_TYPE.PUBSUB) {
      delete this.email;
      delete this.subject;
      this.additionalMessageFields = this.additionalMessageFields?.map(({value, fieldName}) => {
        return {
          value: fieldName === AdditionalMessageFieldTypes.EventSeverity ? this.parseSeverityValue(value as TRIGGER_SIGNAL_TYPE) : value,
          fieldName,
        } as AdditionalMessageField;
      }) || null;
    } else if (trigger.triggerActionType === TRIGGER_ACTION_TYPE.NOTIFICATION) {
      delete this.email;
      delete this.topic;
    } else {
      delete this.topic;
    }
  }

  private parseSeverityValue(event: TRIGGER_SIGNAL_TYPE): number {
    switch (event) {
      case TRIGGER_SIGNAL_TYPE.ERROR:
        return 0;
      case TRIGGER_SIGNAL_TYPE.WARNING:
        return 1;
      case TRIGGER_SIGNAL_TYPE.INHIBIT:
        return 2;
      case TRIGGER_SIGNAL_TYPE.INFO:
        return 3;
      case TRIGGER_SIGNAL_TYPE.DEBUG:
        return 4;
    }
  }
}
